require('./bootstrap');

import Vue from 'vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import VueMeta from 'vue-meta';
import FlagIcon from 'vue-flag-icon';
import {
  HasError,
  AlertError,
  AlertSuccess,
} from 'vform/src/components/bootstrap4';
import VueSweetalert2 from 'vue-sweetalert2';
import vSelect from 'vue-select';
import Switches from 'vue-switches';
import vuetify from './plugins/vuetify';
import { CoolSelectPlugin } from 'vue-cool-select';
import VueCurrencyFilter from 'vue-currency-filter';
import ToggleButton from 'vue-js-toggle-button';
import Multiselect from 'vue-multiselect';
import InputColorPicker from 'vue-native-color-picker';
/*import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import vco from "v-click-outside"
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'*/

import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/design/app.scss';
import '@/assets/design/custom/plugins/theme.scss';
import 'vue-cool-select/dist/themes/bootstrap.css';
import 'vue-orgchart/dist/style.min.css';
//import 'vue-multiselect/dist/vue-multiselect.min.css';

import App from './App.vue';
import Default from './layouts/DefaultLayout';
import Auth from './layouts/AuthLayout';

import mixinConfig from './mixins/mixinConfig';
import mixinAuth from './mixins/mixinAuth';
import mixinAlerte from './mixins/mixinAlerte';

import {
  mixinSourcing,
  mixinContrat,
  mixinDemande,
  mixinEB,
  mixinNoteFrais,
  mixinOffre,
  mixinBudget,
  mixinCommon,
} from './mixins/achat';

import { mixinOF, mixinEtape } from './mixins/gpao';

import {
  mixinPO,
  mixinOE,
  mixinEC,
  mixinEO,
  mixinFormation,
  mixinSession,
  mixinChkQuestion,
  mixinEntretien,
} from './mixins/rh';

import ButtonLoader from './components/ButtonLoader';
import BreadCrumd from './components/BreadCrumd';
import Relationship from './components/Relationship';
//import VuePusher from 'vue-pusher';
//import Pusher from 'pusher-js';
///Pusher.logToConsole = true;

// i18n
import i18n from './locales/i18n';

Vue.use(BootstrapVue);
Vue.use(VueMeta);
Vue.use(FlagIcon);
Vue.use(CoolSelectPlugin);
Vue.use(VueSweetalert2);
Vue.use(ToggleButton);
Vue.use(InputColorPicker);

/*
Vue.use(Vuelidate)
Vue.use(vco)
Vue.use(VueMask)

Vue.use(BootstrapVue)
*/
/*
Vue.config.productionTip = false
Vue.component('apexchart', VueApexCharts)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
*/

Vue.component('default-layout', Default);
Vue.component('auth-layout', Auth);
Vue.component('ButtonLoader', ButtonLoader);
Vue.component(HasError.name, HasError);
Vue.component(AlertSuccess.name, AlertSuccess);
Vue.component(AlertError.name, AlertError);
Vue.component('v-custom-select', vSelect);
Vue.component('switches', Switches);
Vue.component('BreadCrumd', BreadCrumd);
Vue.component('Relationship', Relationship);
Vue.component('multiselect', Multiselect);

Vue.mixin(mixinConfig);
Vue.mixin(mixinAuth);
Vue.mixin(mixinAlerte);

/** Mixins Achat */
[
  mixinSourcing,
  mixinContrat,
  mixinDemande,
  mixinEB,
  mixinNoteFrais,
  mixinOffre,
  mixinBudget,
  mixinCommon,
].forEach((x) => Vue.mixin(x));

[mixinOF, mixinEtape].forEach((x) => Vue.mixin(x));

/** Mixins RH */
[
  mixinPO,
  mixinOE,
  mixinEC,
  mixinEO,
  mixinFormation,
  mixinSession,
  mixinChkQuestion,
  mixinEntretien,
].forEach((x) => Vue.mixin(x));

/** Mixins GPAO */
[mixinOF, mixinEtape].forEach((x) => Vue.mixin(x));
//Vue.mixin(mixinPO);

// FILTERS
import './filters/formatDate';

/*Vue.use(VuePusher, {
  api_key: '2762f4d958726b891e5e',
  options: {
    cluster: 'eu',
    encrypted: true,
  },
});*/

Vue.config.productionTip = false;
store.dispatch('app/loadSociete').then(() => {
  if (store.getters['app/societe'].devise) {
    Vue.use(VueCurrencyFilter, {
      symbol: store.getters['app/societe'].devise.symbole,
      thousandsSeparator: ' ',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'back',
      symbolSpacing: true,
    });
  } else {
    Vue.use(VueCurrencyFilter, store.getters['app/defaultCurrencyConfig']);
  }

  store.dispatch('auth/checkUser').then(() => {
    new Vue({
      vuetify,
      router,
      i18n,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });
});
